import Loader from "@/components/loader/Loader.vue";
import { toTranslationKey } from "@/utils/stringFormat";
import { CalendarTypeEnum } from "@/enums/CalendarTypeEnum";
import moment from "moment/moment";
import { EventsTypes } from "@/enums/EventsTypes";
import EventPreviewCard from "@/views/calender/event-preview-card/EventPreviewCard.vue";
import { EventLocations } from "@/enums/EventLocations";
import { PremiumServiceEventTypes } from "@/enums/PremiumServiceEventTypes";
import { fixString } from "@/utils/fixString";
import { CalendarScreenTypeEnum } from "@/enums/CalendarScreenTypeEnum";

export default {
  name: "PremiumServicesAppointments",
  components: {
    Loader, EventPreviewCard
  },
  data() {
    return {
      today: new Date(),
      focus: '',
      type: 'week',
      typeToLabel: CalendarTypeEnum,
      isOpenCalendarCard: false,
      selectedWing: null,
      selectedService: null
    }
  },

  created() {
    this.moveToCurrentWeek();
    this.$store.dispatch("getEventLocations");
    this.$store.dispatch('getAppointmentEvents', { start: moment().add(1, "months").toDate(), end: moment().add(-1, "months").toDate() });
  },

  computed: {
    eventTypes() {
      return EventsTypes;
    },
    wings() {
      return this.$store.state.eventLocationModule.eventLocations.filter(x => x.type === EventLocations.Wing);
    },
    appointmentServices() {
      return this.$store.state.additionalServicesModule.additionalServices.filter(x => (x.type === PremiumServiceEventTypes.ByAppointment) || (x.type === PremiumServiceEventTypes.Request && x?.byAppointment));
    },
    appointmentEvents() {
      return this.$store.state.calenderModule.appointmentEvents;
    },
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    events() {
      let events = this.appointmentEvents.map(dbEvt => ({
        name: dbEvt.name,
        id: dbEvt.id,
        imageUrl: dbEvt.imageUrl,
        attendees: dbEvt.attendees,
        description: dbEvt.description,
        isVirtualEvent: dbEvt.isVirtualEvent,
        going: dbEvt.going,
        notgoing: dbEvt.notgoing,
        goingLen: dbEvt.going?.length,
        notgoingLen: dbEvt.notgoing?.length,
        invitees: dbEvt.invitees,
        attendeesLen: dbEvt.invitees?.length,
        isRecurring: dbEvt.isRecurring,
        start: this.formatDate(moment(dbEvt.start.seconds * 1000).toDate(), true),
        end: this.formatDate(dbEvt.end ? moment(dbEvt.end.seconds * 1000).toDate() : null, true),
        color: this.getColor(dbEvt.type, dbEvt.allDay, dbEvt.isPublished),
        type: dbEvt.type,
        allDay: dbEvt.allDay,
        location: dbEvt.location,
        createdByResidentId: dbEvt.createdByResidentId,
        createdByStaffId: dbEvt.createdByStaffId,
        createdByFamilyUserId: dbEvt.createdByFamilyUserId,
        isPublished: dbEvt.isPublished,
        scheduledPublishDateTime: dbEvt.scheduledPublishDateTime || null,
        wing: dbEvt.wing,
        conciergeRequestId: dbEvt.conciergeRequestId || null,
        serviceRequestsResidentsNames: dbEvt.serviceRequestsResidentsNames
      }));

      if (this.selectedWing) {
        events = events.filter(x => x.wing === this.selectedWing && x.isPublished === true)
      }

      if(this.selectedService?.id){
        events = events.filter(x => x.invitees.includes(this.selectedService.id))
      }

      return events
    }
  },
  methods: {
    fixString(str, cut) {
      return fixString(str, 15, cut)
    },
    moveToCurrentWeek() {
      if (this.$route.params?.currentWeek) {
        this.focus = this.$route.params.currentWeek;
      }
    },
    getColor(type, allDay): string {
      if (allDay && type == EventsTypes.PremiumServices) {
        return '#8cd18e'
      }
      else if (type == EventsTypes.PremiumServices) {
        return '#4caf50'
      }
      return '#ffa500'
    },
    formatDate(a, withTime): string {
      if (!a) return ''

      return withTime
        ? `${a.getFullYear()}-${a.getMonth() +
        1}-${a.getDate()} ${a.getHours()}:${(a.getMinutes() < 10 ? '0' : '') + a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    prev(): void {
      this.$refs.calendarAppointment.prev();
    },
    next(): void {
      this.$refs.calendarAppointment.next();
    },
    convertToTranslationKey(text: string) {
      return toTranslationKey(text)
    },
    intervalFormatter(locale, getOptions) {
      const format = this.facility.timeFormat.split(' ')[1] || ''
      let timeFormatted = moment(locale.time, ["HH:mm"]).format(`${format == 'A' ? 'h' : 'H'}${format ? ' ' + format : ''}`)
      timeFormatted = timeFormatted === '0'?'24':timeFormatted
      return timeFormatted;
    },
    showEvent({ nativeEvent, event }): void {
      this.isOpenCalendarCard = true;
      this.$refs.eventPreviewCard.open(nativeEvent.target, event, CalendarScreenTypeEnum.Calendar);
    },
    viewDay({ date }): void {
      let route = true;
      const currentDate = moment(date).format("YYYY-MM-DD");
      this.appointmentEvents.forEach(event => {
        const eventStart = moment(event.start).format("YYYY-MM-DD");
        const eventEnd = moment(event.end).format("YYYY-MM-DD");
        if (currentDate >= eventStart && currentDate <= eventEnd) {
          this.focus = date;
          this.type = 'day';
          this.dateDefault = date;
          route = false;
        }
      });
      if (route) {
        this.$router.push({
          name: 'NewCalendarItem',
          params: { dateSelected: date },
        });
      }
    },
    closeCalendarCard() {
      this.isOpenCalendarCard = false
    },
    async onRangeChange(range) {
      const start = moment(range.start.date).add(-1, 'months').toDate()
      const end = moment(range.end.date).add(1, 'months').toDate()

      if (this.$refs.calendarAppointment) { this.$refs.calendarAppointment.scrollToTime('07:00') }

      await this.$store.dispatch('getAppointmentEvents', { start: start, end: end });
    }
  }
}